<template>
 <ActivityHistory title="Driver Activity History" :subtitle="subtitleText" :records="records" :loading="loading" @close="closeDialog"></ActivityHistory>
</template>

<script>
import axios from "@/axios/axios-global";
import ActivityHistory from "@/components/common/ActivityHistory.vue";
export default {
 name: "DriversRemarksList",
 components: { ActivityHistory },
 props: {
  token: String,
 },
 data: () => {
  return {
   driverDetails: {},
   loading: false,
  };
 },
 mounted() {
  this.getDriverDetails();
 },
 computed: {
  subtitleText() {
   return [this.driverDetails.name, this.driverDetails.mobile].filter(Boolean).join(" · ");
  },
  records() {
   const reasons = (this.driverDetails && this.driverDetails.reason) || [];
   return reasons.map((remark) => ({
    employee: remark.remarksBy && typeof remark.remarksBy === "object" ? remark.remarksBy.name : remark.remarksBy,
    reason: remark.reason,
    date: remark.date,
    action: remark.action,
   }));
  },
 },
 methods: {
  async getDriverDetails() {
   this.loading = true;
   try {
    const response = await axios.post("driver/details", { driverId: this.token });
    this.driverDetails = response.data || {};
   } catch (error) {
    console.error(error);
   } finally {
    this.loading = false;
   }
  },
  closeDialog() {
   this.$emit("edit-dialog");
  },
 },
};
</script>
